import ProgressBar from "Pages/GcPrecon/GcPreconCommercial/ProgressBar";
import { formatCurrency } from "../constants/sovSetupData";
import NoData from "Pages/Admin/InspectorAssign/components/NoData";

interface TradeItem {
  label: string;
  value: number;
  pct: number;
  colorHex?: string;
}

interface TradeBreakdownProps {
  rows: TradeItem[];
}

export default function TradeBreakdown({ rows }: TradeBreakdownProps) {
  if (!rows.length) {
    return <NoData />;
  }

  return (
    <div className="sovTradeBreakdown">
      {rows.map((item) => (
        <div key={item.label} className="sovTradeRow">
          <span className="sovTradeLabel">{item.label}</span>
          <ProgressBar percentage={item.pct} barOnly color={item.colorHex} />
          <span className="sovTradeValue">{formatCurrency(item.value)}</span>
          <span className="sovTradePct">{item.pct}%</span>
        </div>
      ))}
    </div>
  );
}
